import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gridGap: theme.spacing(1),
    textAlign: 'center',
    color: '#fff',
    padding: theme.spacing(1.5, 0),
  },
  count: {
    fontWeight: 'bold',
  },
  title: {},
}));

const ReportItem = ({
  color = '#fff',
  count,
  title = '',
  link = '#',
  contrast = true,
  colspan = 1,
}) => {
  const classes = useStyles();
  return (
    <Link to={link} style={{ gridColumn: `${colspan} span` }}>
      <div
        className={classes.root}
        style={{ background: color, color: contrast ? 'white' : '#000' }}
      >
        {count !== undefined ? (
          <span className={classes.count}>{count}</span>
        ) : null}
        <span className={classes.title}>{title}</span>
      </div>
    </Link>
  );
};

export default React.memo(ReportItem);
